export enum ValueSteps {
    VALUE_ZERO_TO_ONE = '0/1',
    VALUE_ONE_TO_ONE = '1/1',
    VALUE_ZERO_TO_TWO = '0/2',
    VALUE_ONE_TO_TWO = '1/2',
    VALUE_TWO_TO_TWO = '2/2',
  }
  